import {
  mergeAdjacentTimeRanges,
  parseTimeRange,
  TimeRange
} from '../utils/time.util';
import { AbstractControl, ValidationErrors } from '@angular/forms';

export class TimeValidators {
  static isTimeInRange(timeSlots: string[]) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control?.value) {
        return null;
      }

      if (!timeSlots || timeSlots.length === 0) {
        return { timeRange: true };
      }

      const value: Date = control.value;
      const timeRanges: TimeRange[] = timeSlots
        .map((timeSlot: string): TimeRange | null => parseTimeRange(timeSlot))
        .filter((timeSlot: TimeRange | null) => !!timeSlot);

      const hours: number = value.getHours();
      const minutes: number = value.getMinutes();
      const valueMilliseconds: number =
        hours * 60 * 60 * 1000 + minutes * 60 * 1000;

      const isTimeInRange: boolean = timeRanges.some(
        (timeRange: TimeRange) =>
          timeRange.start.milliseconds <= valueMilliseconds &&
          timeRange.end.milliseconds >= valueMilliseconds
      );

      if (!isTimeInRange) {
        console.log(timeRanges);
        const mergedRanges: string[] = mergeAdjacentTimeRanges(timeRanges);
        return {
          timeRange: {
            current: value,
            timeRanges: mergedRanges.length > 0 ? mergedRanges : timeSlots
          }
        };
      }

      return null;
    };
  }
}
